import dayjs from "dayjs";
import i18n from "../i18n";
import Utils from "../Utils";
import services from "./../services";

const strict = true;

const getDefaultState = () => {
  return {
    appointmentState: null,
    billState: null,
    isDoneOrInBillAppointment: false,
    isDoneAppointment: false,
    isInBillAppointment: false,
    currentStep: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE,
    type: "SLOT",
    typeMap: {
      SLOT: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR,
      TIMEPERIOD: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE,
      BYPHONE: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE
    },
    //  --- B O O K I N G  W I Z A R D  S T E P S ---
    // id: 1 Service
    // id: 2 Diagnostic Question / Pathology
    // id: 3 Doctor (only if service.macroArea === "VSP")
    // id: 4 Calendar (only if state.type === "SLOT")
    // id: 5 Portal Date (only if state.type === "TIMEPERIOD" (BYPORTAL))
    // id: 6 Motivation
    steps: {
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE,
        name: "prestazione",
        inMenu: true,
        completed: false,
        visited: true,
        active: false,
        title: "bookingWizard.service.title",
        menuTitle: "bookingWizard.menu.service",
        selectedInfo: "",
        icon: "widgets",
        searchResults: [],
        searchText: "",
        searchHasBeenPerformed: false,
        instructions: "bookingWizard.service.instructions",
        isValid: state => {
          return (
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .service.serviceId &&
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .ancillaries
          );
        },
        nextStep: state => {
          if (state.isDoneOrInBillAppointment) {
            return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS;
          } else {
            return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS;
          }
        },
        prevStep: () => {
          return {};
        },
        info: {
          originalServiceId: null,
          isChanged: false,
          initValue: null,
          services: [],
          service: {},
          ancillaries: [],
          selectedAncillaries: []
        },
        component: "service-selection"
      },
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS,
        name: "quesitoDiagnostico",
        inMenu: state => {
          if (state.isDoneOrInBillAppointment) {
            return false;
          }
          return true;
        },
        completed: false,
        visited: false,
        active: false,
        title: "bookingWizard.pathologyTitle",
        menuTitle: "bookingWizard.menu.diagnosticQuestion",
        selectedInfo: "",
        icon: "contact_support",
        instructions: "bookingWizard.pathology.instructions",
        isValid: state => {
          return (
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS].info
              .pathology != ""
          );
        },
        nextStep: state => {
          if (
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .service.macroArea === "VSP"
          ) {
            return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR;
          } else {
            if (state.type === "SLOT") {
              return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR;
            } else {
              return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE;
            }
          }
        },
        prevStep: () => {
          return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE;
        },
        info: {
          originalPathology: "",
          isChanged: false,
          pathology: ""
        },
        component: "service-diagnostic-question"
      },
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR,
        name: "medico",
        inMenu: state => {
          if (state.isDoneOrInBillAppointment) {
            return false;
          } else {
            let service =
              state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
                .service;
            return service && service.macroArea === "VSP";
          }
        },
        completed: false,
        visited: false,
        active: false,
        title: "bookingWizard.doctorsTitle",
        menuTitle: "bookingWizard.menu.doctor",
        icon: "fas fa-user-md",
        selectedInfo: "",
        instructions: "bookingWizard.doctors.instructions",
        searchResults: [],
        searchText: "",
        isValid: state => {
          return state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info
            .doctor.doctorId;
        },
        nextStep: state => {
          return state.type === "SLOT"
            ? Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR
            : Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE;
        },
        prevStep: () => {
          return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS;
        },
        info: {
          originalDoctorId: null,
          isChanged: false,
          doctors: [],
          doctor: {}
        },
        component: "doctor-selection"
      },
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR,
        name: "calendario",
        inMenu: state => {
          let bookingType =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .service.bookingType;
          if (state.isDoneOrInBillAppointment) {
            return false;
          } else {
            return bookingType === "SLOT";
          }
        },
        completed: false,
        visited: false,
        active: false,
        title: "bookingWizard.dateTimeTitle",
        menuTitle: "bookingWizard.menu.dateTime",
        icon: "fas fa-calendar-day",
        selectedInfo: "",
        isValid: state => {
          let d =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR].info.date;
          let t =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR].info.time;
          return d != null && t != null;
        },
        nextStep: () => {
          return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS;
        },
        prevStep: state => {
          let service =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .service;
          return service.macroArea === "VSP"
            ? Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR
            : Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS;
        },
        info: {
          originalDate: null,
          originalTime: null,
          isChanged: false,
          date: "",
          time: ""
        },
        component: "slot-calendar"
      },
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE,
        name: "portale",
        inMenu: state => {
          let bookingType =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
              .service.bookingType;
          if (state.isDoneOrInBillAppointment) {
            return false;
          } else {
            return bookingType === "TIMEPERIOD";
          }
        },
        completed: false,
        visited: false,
        active: false,
        title: "bookingWizard.dateTimeTitle",
        menuTitle: "bookingWizard.menu.dateTime",
        icon: "fas fa-calendar-day",
        selectedInfo: "",
        isValid: state => {
          let d =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE].info
              .date;
          let t =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE].info
              .time;
          return d != null && t != null;
        },
        nextStep: () => {
          return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS;
        },
        prevStep: state => {
          return state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
            .service.macroArea === "VSP"
            ? Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR
            : Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS;
        },
        info: {
          originalDate: null,
          originalTime: null,
          isChanged: false,
          date: "",
          time: ""
        },
        component: "timeperiod-calendar"
      },
      [Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS]: {
        id: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS,
        name: "causale",
        inMenu: true,
        completed: false,
        visited: false,
        active: false,
        title: "bookingWizard.pathologyTitle",
        menuTitle: "bookingWizard.menu.motivation",
        selectedInfo: "",
        icon: "assignment_returned",
        instructions: "bookingWizard.pathology.instructions",
        isValid: state => {
          let motivation =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS].info
              .replaceMotivation;
          let reason =
            state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS].info
              .replaceReason;
          return (
            state.replaceMotivations.includes(motivation) ||
            (motivation === "OTHER" && reason.length > 0 && reason.length < 51)
          );
        },
        nextStep: () => {
          // end of wizard
        },
        prevStep: state => {
          if (state.isDoneOrInBillAppointment) {
            return Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE;
          } else {
            return state.type === "SLOT"
              ? Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR
              : Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE;
          }
        },
        info: {
          replaceMotivation: "",
          replaceReason: ""
        },
        component: "select-motivation"
      }
    },
    allReplaceMotivations: [
      { stepId: 1, description: ["CHANGEPERFORMANCE"] },
      {
        stepId: 2,
        description: [
          "LACKOFNECESSARYDOCUMENTATION",
          "DIAGNOSTICQUESTIONNOTALLOWED"
        ]
      },
      {
        stepId: 3,
        description: [
          "REQUESTEDDOCTORNOLONGERAFFILIATED",
          "REQUESTEDDOCTORNOTPRESENT"
        ]
      },
      { stepId: 4, description: ["MACHINERYNOTAVAILABLE", "DATENOTAVAILABLE"] }
    ],
    replaceMotivations: []
  };
};

const state = getDefaultState();

const getters = {
  getIsDoneOrInBillAppointment: state => state.isDoneOrInBillAppointment,
  getIsDoneAppointment: state => state.isDoneAppointment,
  getIsInBillAppointment: state => state.isInBillAppointment,
  getStepInitValue: state => stepId => {
    return state.steps[stepId].info.initValue;
  },
  isValid: state => state.steps[state.currentStep].isValid(state),
  getCurrentStep: state => {
    return state.steps[state.currentStep];
  },
  getCurrentStepIndex: state => state.currentStep,
  getSteps: state => state.steps,
  getStepByName: state => name => {
    for (const key in state.steps) {
      if (Object.prototype.hasOwnProperty.call(state.steps, key)) {
        const step = state.steps[key];
        if (step.name == name) return step;
      }
    }
    return null;
  },
  getMenuSteps: state => {
    let filtered = {};
    for (const key in state.steps) {
      if (Object.prototype.hasOwnProperty.call(state.steps, key)) {
        const step = state.steps[key];
        let include = false;

        if (typeof step.inMenu === "function") include = step.inMenu(state);
        else include = step.inMenu;

        if (include)
          filtered[step.id] = {
            ...step
          };
      }
    }
    return filtered;
  },
  getSearchInput: state => state.steps[state.currentStep].info.searchInput,
  getSearchHasBeenPerformed: state => step =>
    state.steps[step || state.currentStep].searchHasBeenPerformed || false,
  getSearchResults: state => step => {
    return state.steps[step || state.currentStep].searchResults;
  },
  getSearchText: state => step =>
    state.steps[step || state.currentStep].searchText || "",
  getServices: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.services,
  getService: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.service,
  getAncillaries: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.ancillaries,
  getSelectedAncillaries: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info
      .selectedAncillaries,
  getPathology: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS].info.pathology,
  getOriginalDoctorId: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info
      .originalDoctorId,
  getDoctors: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info.doctors,
  getDoctor: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info.doctor,
  getSlotDate: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR].info.date,
  getSlotTime: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR].info.time,
  getTimeperiodDate: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE].info.date,
  getTimeperiodTime: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE].info.time,
  getAllReplaceMotivations: state => state.allReplaceMotivations,
  getServiceIsChanged: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.isChanged,
  getPathologyIsChanged: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS].info.isChanged,
  getDoctorIsChanged: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info.isChanged,
  getCalendarIsChanged: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR].info.isChanged,
  getPortalDateIsChanged: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE].info.isChanged,
  getReplaceMotivations: state => state.replaceMotivations,
  getReplaceMotivation: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS].info
      .replaceMotivation,
  getReplaceReason: state =>
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS].info
      .replaceReason
};

const mutations = {
  RESET(state) {
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  setAppInfoAndBillInfo(state, obj) {
    let appState = obj.appointmentState;
    let billState = obj.billState;
    state.appointmentState = appState;
    state.billState = billState;
    let billStatesBeforeFinancial = ["DRAFT", "SENTBACK"];
    let billStatesAlreadyInFinancial = [
      "ACCEPTED",
      "VERIFIED",
      "TOPAY",
      "INPAYMENT",
      "CROTOBECONFIRMED",
      "UNPAID",
      "PAID",
      "CLOSED"
    ];
    if (appState === "DONE") {
      state.isDoneOrInBillAppointment = true;
      state.isDoneAppointment = true;
      state.isInBillAppointment = false;
    } else if (
      appState === "INBILL" &&
      (billStatesBeforeFinancial.includes(billState) ||
        billStatesAlreadyInFinancial.includes(billState))
    ) {
      state.isDoneOrInBillAppointment = true;
      state.isDoneAppointment = false;
      state.isInBillAppointment = true;
    } else {
      state.isDoneOrInBillAppointment = false;
      state.isDoneAppointment = false;
      state.isInBillAppointment = false;
    }
  },
  nextStep(state) {
    state.steps[state.currentStep].active = false;
    state.steps[state.currentStep].completed = true;
    state.currentStep = state.steps[state.currentStep].nextStep(state);
    state.steps[state.currentStep].active = true;
    state.steps[state.currentStep].visited = true;
  },
  previousStep(state) {
    resetSteps(state.steps, [state.currentStep]);
    state.currentStep = state.steps[state.currentStep].prevStep(state);
    state.steps[state.currentStep].active = true;
  },
  editStep(state, id) {
    state.steps[state.currentStep].active = false;
    state.currentStep = id;
    state.steps[state.currentStep].active = true;
    // reset all the steps starting from the new current step plus 1
    resetStepsForEditStep(state.steps, state.currentStep + 1, 7);
  },
  stepInitValue(state, obj) {
    state.steps[obj.stepId].info.initValue = obj.service;
  },
  searchResults(state, { results, step }) {
    state.steps[step || state.currentStep].searchResults = results;
  },
  searchText(state, input) {
    state.steps[state.currentStep].searchText = input;
  },
  searchHasBeenPerformed(state, value) {
    state.steps[state.currentStep].searchHasBeenPerformed = value;
  },
  setOriginalServiceId(state, serviceId) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE
    ].info.originalServiceId = serviceId;
  },
  setServices(state, services) {
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.services =
      services;
  },
  setAncillaries(state, ancillaries) {
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE].info.ancillaries =
      ancillaries;
  },
  setSelectedAncillaries(state, ancillaries) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE
    ].info.selectedAncillaries = ancillaries;
    //add ancillaries (num x description) to service selected info
    let serviceStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE];
    let ancillaryNames = ancillaries
      .map(a => a.count + "x " + a.description)
      .join("</br>");
    serviceStep.selectedInfo = ancillaryNames
      ? `Prestazione richiesta: ${serviceStep.selectedInfo}</br>Prestazioni ancillari:</br>${ancillaryNames}`
      : `Prestazione richiesta: serviceStep.selectedInfo`;
  },
  removeAncillaryFromSelectdList(state, index) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE
    ].info.selectedAncillaries.splice(index, 1);
  },
  updateAncillaryCount(state, { index, count }) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE
    ].info.selectedAncillaries[index].count = count;
  },
  setService(state, service) {
    let serviceStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE];
    serviceStep.info.service = service;
    state.type = service.bookingType;
    serviceStep.selectedInfo = service.label
      ? `Prestazione richiesta: ${service.label.defaultValue}`
      : null;
    serviceStep.info.isChanged =
      serviceStep.info.originalServiceId != service.serviceId;
  },
  setOriginalPathology(state, description) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS
    ].info.originalPathology = description;
  },
  setPathology(state, description) {
    let pathologyStep =
      state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DIAGNOSIS];
    pathologyStep.info.pathology = description;
    pathologyStep.info.isChanged =
      pathologyStep.info.originalPathology != description;
    pathologyStep.selectedInfo = description;
  },
  setOriginalDoctorId(state, doctorId) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR
    ].info.originalDoctorId = doctorId;
  },
  setDoctors(state, doctors) {
    state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR].info.doctors =
      doctors;
  },
  setDoctor(state, doctor) {
    let doctorStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.DOCTOR];
    doctorStep.info.doctor = doctor;
    let t = i18n ? i18n.t("bookingWizard.doctor") : "Medico";
    let doctorFullName = "";
    if (doctor && doctor.doctorId === "fake-doctor-id") {
      doctorFullName = t.concat(": ").concat("nessuna preferenza");
    } else {
      doctorFullName = t
        .concat(": ")
        .concat(doctor.name)
        .concat(" ")
        .concat(doctor.surname);
    }
    doctorStep.selectedInfo = doctorFullName;
    doctorStep.info.isChanged =
      doctorStep.info.originalDoctorId != doctor.doctorId;
    let stepIdsToBeReset = [
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR,
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE
    ];
    state.steps = resetSteps(state.steps, stepIdsToBeReset);
  },
  setOriginalDateAndTime(state, payload) {
    let dateStep = state.typeMap[state.type];
    state.steps[dateStep].info.originalDate = payload.date;
    state.steps[dateStep].info.originalTime = payload.time;
  },
  setSlotDate(state, date) {
    let dateStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR];
    dateStep.info.date = date;
    let fullDate = `${date}T${dateStep.info.time}`;
    dateStep.selectedInfo = `${dayjs(fullDate).format("dddd DD MMMM")} ${i18n.t(
      "bookingWizard.toTime"
    )} ${dayjs(fullDate).format("HH:mm")}`;
    dateStep.info.isChanged =
      dateStep.info.originalDate != date &&
      dateStep.info.originalTime != dateStep.info.time;
  },
  setSlotTime(state, time) {
    let dateStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.CALENDAR];
    dateStep.info.time = time;
    let fullDate = `${dateStep.info.date}T${time}`;
    dateStep.selectedInfo = `${dayjs(fullDate).format("dddd DD MMMM")} ${i18n.t(
      "bookingWizard.toTime"
    )} ${dayjs(fullDate).format("HH:mm")}`;
    dateStep.info.isChanged =
      dateStep.info.originalDate != dateStep.info.date &&
      dateStep.info.originalTime != time;
  },
  setTimeperiodDate(state, date) {
    let dateStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE];
    dateStep.info.date = date;
    let fullDate = `${date}T${dateStep.info.time}`;
    dateStep.selectedInfo = `${dayjs(fullDate).format("dddd DD MMMM")} ${i18n.t(
      "bookingWizard.toTime"
    )} ${dayjs(fullDate).format("HH:mm")}`;
    dateStep.info.isChanged =
      dateStep.info.originalDate != date &&
      dateStep.info.originalTime != dateStep.info.time;
  },
  setTimeperiodTime(state, time) {
    let dateStep = state.steps[Utils.EDIT_APPOINTMENT_WIZARD_STEPS.PORTAL_DATE];
    dateStep.info.time = time;
    let fullDate = `${dateStep.info.date}T${time}`;
    dateStep.selectedInfo = `${dayjs(fullDate).format("dddd DD MMMM")} ${i18n.t(
      "bookingWizard.toTime"
    )} ${dayjs(fullDate).format("HH:mm")}`;
    dateStep.info.isChanged =
      dateStep.info.originalDate != dateStep.info.date &&
      dateStep.info.originalTime != time;
  },
  setReplaceMotivations(state, motivations) {
    state.replaceMotivations = motivations;
  },
  setReplaceMotivation(state, replaceMotivation) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS
    ].info.replaceMotivation = replaceMotivation;
  },
  setReplaceReason(state, replaceReason) {
    state.steps[
      Utils.EDIT_APPOINTMENT_WIZARD_STEPS.MOTIVATIONS
    ].info.replaceReason = replaceReason;
  }
};

const actions = {
  async resetAppointmentWizard({ commit }) {
    await commit("RESET");
  },
  async initAppointmentInfoAndBillInfoData({ commit, rootGetters }) {
    let appointmentState = rootGetters["appointments/activeAppointment"]
      ? rootGetters["appointments/activeAppointment"].state
      : null;
    let billState = rootGetters["bills/activeBillInfo"]
      ? rootGetters["bills/activeBillInfo"].billState
      : null;
    await commit("setAppInfoAndBillInfo", {
      appointmentState: appointmentState,
      billState: billState
    });
  },
  async fetchInitService({ commit }, payload) {
    try {
      let service = await services.bookingsService.getServiceWithId(payload);
      commit("stepInitValue", {
        stepId: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE,
        service: service
      });
      commit("setOriginalServiceId", service ? service.serviceId : null);
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "booking";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async getServices({ commit }, officeId) {
    try {
      let serviceList =
        await services.hfManagementService.fetchHFServicesForAppointment(
          officeId
        );
      serviceList.sort((s1, s2) =>
        s1.label.defaultValue.localeCompare(s2.label.defaultValue)
      );
      commit("searchResults", {
        results: serviceList,
        step: Utils.EDIT_APPOINTMENT_WIZARD_STEPS.SERVICE
      });
      commit("searchHasBeenPerformed", true);
      commit("setServices", serviceList);
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "hfManagement";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async initPathologyFromOriginalAppointment({ commit, rootGetters }) {
    let pathology = rootGetters["appointments/activeAppointment"].pathology;
    commit("setOriginalPathology", pathology);
    commit("setPathology", pathology);
  },
  async initDoctorIdFromOriginalAppointment({ commit, rootGetters }) {
    let doctorId = rootGetters["appointments/activeAppointment"].doctorId;
    commit("setOriginalDoctorId", doctorId);
  },
  async getDoctorsByOfficeService({ commit, rootGetters, getters }) {
    try {
      let doctors = await services.bookingsService.getDoctorsByOfficeService({
        id: rootGetters["hfManagement/officeId"],
        serviceId: getters["getService"].serviceId
      });
      let noDoctorObj = {
        doctorId: "fake-doctor-id",
        name: "Non voglio selezionare",
        surname: "un medico"
      };
      doctors.unshift(noDoctorObj);
      commit("setDoctors", doctors);
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "hfManagement";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async initDateAndTimeFromOriginalAppointment({ commit, rootGetters }) {
    let originalDate =
      rootGetters["appointments/activeAppointment"].appointmentScheduleDate;
    commit("setOriginalDateAndTime", {
      date: dayjs(originalDate).format("YYYY-MM-DD"),
      time: dayjs(originalDate).format("HH:mm")
    });
  },
  async getReplaceMotivations({ state, commit, getters }) {
    let flowType = state.type;
    let allReplaceMotivations = getters["getAllReplaceMotivations"];
    let step1IsChanged = getters["getServiceIsChanged"];
    let step2IsChanged = getters["getPathologyIsChanged"];
    let step3IsChanged = getters["getDoctorIsChanged"];
    let stepDateIsChanged =
      flowType === "SLOT"
        ? getters["getCalendarIsChanged"]
        : getters["getPortalDateIsChanged"];
    let allowedStepId = [];
    if (step1IsChanged) allowedStepId.push(1);
    if (step2IsChanged) allowedStepId.push(2);
    if (step3IsChanged) allowedStepId.push(3);
    if (stepDateIsChanged) allowedStepId.push(4);
    let validMotivations = allReplaceMotivations
      .filter(step => allowedStepId.includes(step.stepId))
      .map(step => step.description);
    let motivations = [].concat(...validMotivations);
    commit("setReplaceMotivations", motivations);
  },
  async modifyAppointmentDone({ commit, getters, rootGetters }) {
    try {
      let originalAppointment = rootGetters["appointments/activeAppointment"];
      let payload = {};
      payload.appointmentType = originalAppointment.appointmentType;
      let motivation = getters["getReplaceMotivation"];
      payload.replaceReason = {
        replaceMotivation: motivation,
        replaceReason:
          motivation === "OTHER" ? getters["getReplaceReason"] : "",
        replaceAdditionalInfo: null
      };
      let appointmentDate = originalAppointment.appointmentScheduleDate;
      let date = dayjs(appointmentDate).format("YYYY-MM-DD");
      let time = dayjs(appointmentDate).format("HH:mm");
      payload.dateAndTime = dayjs(`${date}T${time}`).format();
      payload.newServiceId = getters["getService"]
        ? getters["getService"].serviceId
        : null;
      payload.newDoctorId = originalAppointment.doctorId;
      payload.pathology = originalAppointment.pathology;
      let appointmentId = originalAppointment.appointmentId;
      return await services.appointmentsService.callModifyAppointmentDone(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyAppointmentInBillWithBillBeforeFinancial({
    commit,
    getters,
    rootGetters
  }) {
    try {
      let originalAppointment = rootGetters["appointments/activeAppointment"];
      let payload = {};
      payload.appointmentType = originalAppointment.appointmentType;
      let motivation = getters["getReplaceMotivation"];
      payload.replaceReason = {
        replaceMotivation: motivation,
        replaceReason:
          motivation === "OTHER" ? getters["getReplaceReason"] : "",
        replaceAdditionalInfo: null
      };
      let appointmentDate = originalAppointment.appointmentScheduleDate;
      let date = dayjs(appointmentDate).format("YYYY-MM-DD");
      let time = dayjs(appointmentDate).format("HH:mm");
      payload.dateAndTime = dayjs(`${date}T${time}`).format();
      payload.newServiceId = getters["getService"]
        ? getters["getService"].serviceId
        : null;
      payload.newDoctorId = originalAppointment.doctorId;
      payload.pathology = originalAppointment.pathology;
      let appointmentId = originalAppointment.appointmentId;
      return await services.appointmentsService.callModifyAppointmentInBillWithBillBeforeFinancial(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyAppointmentInBillWithBillAlreadyFinancial({
    commit,
    getters,
    rootGetters
  }) {
    try {
      let originalAppointment = rootGetters["appointments/activeAppointment"];
      let payload = {};
      payload.appointmentType = originalAppointment.appointmentType;
      let motivation = getters["getReplaceMotivation"];
      payload.replaceReason = {
        replaceMotivation: motivation,
        replaceReason:
          motivation === "OTHER" ? getters["getReplaceReason"] : "",
        replaceAdditionalInfo: null
      };
      let appointmentDate = originalAppointment.appointmentScheduleDate;
      let date = dayjs(appointmentDate).format("YYYY-MM-DD");
      let time = dayjs(appointmentDate).format("HH:mm");
      payload.dateAndTime = dayjs(`${date}T${time}`).format();
      payload.newServiceId = getters["getService"]
        ? getters["getService"].serviceId
        : null;
      payload.newDoctorId = originalAppointment.doctorId;
      payload.pathology = originalAppointment.pathology;
      let appointmentId = originalAppointment.appointmentId;
      return await services.appointmentsService.callModifyAppointmentInBillWithBillAlreadyFinancial(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifySlotAppointmentService(
    { state, getters, commit },
    { appointmentId }
  ) {
    try {
      let payload = constructModifyServicePayload(state, getters);
      return await services.appointmentsService.modifySlotAppointmentService(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyTimeperiodAppointmentService(
    { state, getters, commit },
    { appointmentId }
  ) {
    try {
      let payload = constructModifyServicePayload(state, getters);
      return await services.appointmentsService.modifyTimeperiodAppointmentService(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyExpostAppointmentService(
    { state, getters, commit },
    { appointmentId }
  ) {
    try {
      let payload = constructModifyServicePayload(state, getters);
      return await services.appointmentsService.modifyExpostAppointmentService(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifySLotAncillaries({ getters, rootGetters, commit }) {
    try {
      let payload = constructModifyAncillariesPayload(getters, rootGetters);
      let appointmentId =
        rootGetters["appointments/activeAppointment"].appointmentId;
      return await services.appointmentsService.modifyAppointmentAncillaries(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyTimeperiodAncillaries({ getters, rootGetters, commit }) {
    try {
      let payload = constructModifyAncillariesPayload(getters, rootGetters);
      let appointmentId =
        rootGetters["appointments/activeAppointment"].appointmentId;
      return await services.appointmentsService.modifyAppointmentAncillaries(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async modifyExpostAncillaries({ getters, rootGetters, commit }) {
    try {
      let payload = constructModifyAncillariesPayload(getters, rootGetters);
      let appointmentId =
        rootGetters["appointments/activeAppointment"].appointmentId;
      return await services.appointmentsService.modifyAppointmentAncillaries(
        appointmentId,
        payload
      );
    } catch (error) {
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },

  async retrieveAncillaries({ commit, rootGetters }, serviceId) {
    try {
      let result = await services.appointmentsService.getAncillariesList({
        officeId: rootGetters["hfManagement/officeId"],
        serviceId: serviceId
      });
      let ancillaries = result?.ancillaryList ?? [];
      if (ancillaries.length > 0) {
        ancillaries = sortByKey(ancillaries, "description", "asc");
      }
      commit("setAncillaries", ancillaries);
      return ancillaries;
    } catch (error) {
      commit("setAncillaries", null);
      let errorDialogDetails = {
        ...error
      };
      if (error.type == Utils.errorTypes.STATUS) {
        errorDialogDetails.dataName = "appointments";
      }
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  }
};

const resetSteps = (
  steps,
  stepsIds = Object.values(Utils.EDIT_APPOINTMENT_WIZARD_STEPS)
) => {
  stepsIds.forEach(sId => {
    let step = steps[sId];
    if (!step) {
      console.log("Found undefined step. Details: ", sId);
    }
    step.active = false;
    step.completed = false;
    step.visited = false;
    step.searchResults = [];
    step.searchText = "";
    step.searchHasBeenPerformed = false;
    Object.keys(step.info).forEach(key => {
      if (step.info[key]) {
        if (typeof step.info[key] === "object") {
          if (step.info[key].length === undefined) {
            step.info[key] = {};
          } else {
            step.info[key] = [];
          }
        } else if (typeof step.info[key] === "string") {
          step.info[key] = "";
        } else if (typeof step.info[key] === "number") {
          step.info[key] = 0;
        }
      }
    });
  });
  return steps;
};

const resetStepsForEditStep = (steps, start, end) => {
  start = start || 0;
  end = end || steps.length;
  for (let i = start; i < end; i++) {
    let step = steps[i];
    step.active = false;
    step.completed = false;
    step.visited = false;
    step.selectedInfo = "";
    step.searchResults = [];
    step.searchText = "";
    step.searchHasBeenPerformed = false;
    Object.keys(step.info).forEach(key => {
      if (step.info[key]) {
        if (typeof step.info[key] === "object") {
          if (step.info[key].length === undefined) {
            step.info[key] = {};
          } else {
            step.info[key] = [];
          }
        } else if (typeof step.info[key] === "string") {
          step.info[key] = "";
        } else if (typeof step.info[key] === "number") {
          step.info[key] = 0;
        }
      }
    });
  }
  return steps;
};

const constructModifyServicePayload = (state, getters) => {
  let payload = {};
  payload.appointmentType = state.type;
  let motivation = getters["getReplaceMotivation"];
  payload.replaceReason = {
    replaceMotivation: motivation,
    replaceReason: motivation === "OTHER" ? getters["getReplaceReason"] : "",
    replaceAdditionalInfo: null
  };
  let calendarStep = state.typeMap[state.type];
  let date = state.steps[calendarStep].info.date;
  let time = state.steps[calendarStep].info.time;
  payload.dateAndTime = dayjs(`${date}T${time}`).format();
  payload.newServiceId = getters["getService"]
    ? getters["getService"].serviceId
    : null;
  payload.newDoctorId = getters["getDoctor"]
    ? getters["getDoctor"].doctorId != "fake-doctor-id"
      ? getters["getDoctor"].doctorId
      : null
    : null;
  payload.pathology = getters["getPathology"];
  payload.prestazioneInPrescrizione = null;
  let ancillaries = getters["getSelectedAncillaries"] || [];
  ancillaries = ancillaries.map(a => ({
    ancillaryId: a.id,
    num: a.count
  }));
  payload.newAncillaryIds = ancillaries;
  return payload;
};

const sortByKey = (array, key, order) => {
  if (order === "asc" || !order) {
    return array.sort((a, b) => {
      let aVal = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
      let bVal = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];
      if (aVal < bVal) return -1;
      else if (aVal > bVal) return 1;
      else return 0;
    });
  } else {
    return array.sort((a, b) => {
      let aVal = a[key];
      let bVal = b[key];
      if (aVal < bVal) return 1;
      else if (aVal > bVal) return -1;
      else return 0;
    });
  }
};

const constructModifyAncillariesPayload = (getters, rootGetters) => {
  let payload = {};
  let ancillaries = getters["getSelectedAncillaries"] || [];
  ancillaries = ancillaries.map(a => ({
    ancillaryId: a.id,
    num: a.count
  }));
  payload.newAncillaryIds = ancillaries;
  return payload;
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
